import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BACKEND
})

const checkCnpj = cnpj => {
  const params = { cnpj }
  
  return instance.get('/cnpj', { params })
}

const checkEmail = email => {
  const params = { email }

  return instance.get('/email', { params })
}

const register = (data) => {
  return instance.post('/registro', data)
}

export default {
  checkCnpj,
  checkEmail,
  register
}
